export default __webpack_public_path__ + "static/media/draftstars-app-icon.151f2315.png";